import React from 'react';
import './GamePageHeaderIconButton.css';
import classNames from 'classnames';
import { SvgIconMask } from '../../../../../../shared/src/components/SvgIconMask';

export const GamePageHeaderIconButton = ({
    onClick,
    iconImage,
    className = null,
    children = null,
}) => {
    const buttonClassName = classNames(
        'game-page-header-icon-button',
        'game-page-header-item-hoverable',
        className,
    );

    return <div className={buttonClassName}
        onClick={onClick}
    >
        <SvgIconMask
            className="game-page-header-icon-button__icon"
            iconUrl={iconImage}
            width={24}
            height={24}
            bgColor="var(--game-page-text-color)"
        />
        {children}
    </div>;
};
